<mat-icon
  *ngIf="career.icon.endsWith('.svg')"
  [svgIcon]="career.icon"
  class="square-icon career-icon">
</mat-icon>

<img
  *ngIf="!career.icon.endsWith('.svg')"
  [src]="career.icon"
  class="square-icon career-icon"
/>

<h3 class="career-title">
  <a [target]="career.linkTarget" [href]="career.link">{{ career.title }}</a>
</h3>
